import { useState } from "react";
import { injectIntl } from "react-intl";
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Tooltip, Typography } from "@mui/material";
import { getMessageString } from "../../utility";
import {
  AUTOCERTIFICAZIONE_PLACEHOLDER,
  BUTTON_DICHIARAZIONE,
  NEWSLETTER_PLACEHOLDER,
  PRIVACY_PLACEHOLDER,
  TOOLTIP_DICHIARAZIONE,
} from "../../modules/language";
import { ModalConsensi } from "./ModalConsensi";

export const CheckboxConsensi = injectIntl(({ intl, formik, autocertificazione, privacy, newsletter }) => {
  const [autodichiarazioneAccepted, setAutocertificazioneAccepted] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showAutocertificazioneModal, setShowAutocertificazioneModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  return (
    <>
      <Grid container spacing={{ xs: 2, sm: 0 }} className="checkboxConsensi">
        {!autodichiarazioneAccepted && (
          <Grid item xs={12} sx={{ display: { md: "none" } }}>
            <Typography sx={{ fontStyle: "italic" }}>{getMessageString(intl, TOOLTIP_DICHIARAZIONE)}</Typography>
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <FormControl error={formik.touched[autocertificazione] && formik.errors[autocertificazione] != null}>
            <FormControlLabel
              required
              control={
                <Tooltip
                  title={getMessageString(intl, TOOLTIP_DICHIARAZIONE)}
                  placement="top-start"
                  arrow
                  sx={{ display: { xs: "none" } }}
                  disableHoverListener={autodichiarazioneAccepted}
                >
                  <span>
                    <Checkbox
                      {...(formik.touched[autocertificazione] &&
                        formik.errors[autocertificazione] != null && { sx: { color: "#871d1d !important" } })}
                      disabled={!autodichiarazioneAccepted}
                      checked={formik.values[autocertificazione]}
                      onChange={(e) => formik.setFieldValue([autocertificazione], e.target.checked)}
                    />
                  </span>
                </Tooltip>
              }
              label={getMessageString(intl, AUTOCERTIFICAZIONE_PLACEHOLDER)}
            />
            {formik.touched[autocertificazione] && formik.errors[autocertificazione] != null && (
              <FormHelperText>{formik.errors[autocertificazione]}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button variant="contained" size="small" onClick={() => setShowAutocertificazioneModal(true)}>
            {getMessageString(intl, BUTTON_DICHIARAZIONE)}
          </Button>
        </Grid>
        {!privacyAccepted && (
          <Grid item xs={12} sx={{ display: { md: "none" } }}>
            <Typography sx={{ fontStyle: "italic" }}>{getMessageString(intl, TOOLTIP_DICHIARAZIONE)}</Typography>
          </Grid>
        )}
        <Grid item xs={12} md={3}>
          <FormControl error={formik.touched[privacy] && formik.errors[privacy] != null}>
            <FormControlLabel
              required
              control={
                <Tooltip
                  title={getMessageString(intl, TOOLTIP_DICHIARAZIONE)}
                  placement="top-start"
                  arrow
                  sx={{ display: { xs: "none" } }}
                  disableHoverListener={privacyAccepted}
                >
                  <span>
                    <Checkbox
                      {...(formik.touched[privacy] && formik.errors[privacy] != null && { sx: { color: "#871d1d !important" } })}
                      disabled={!privacyAccepted}
                      checked={formik.values[privacy]}
                      onChange={(e) => formik.setFieldValue([privacy], e.target.checked)}
                    />
                  </span>
                </Tooltip>
              }
              label={getMessageString(intl, PRIVACY_PLACEHOLDER)}
            />
            {formik.touched[privacy] && formik.errors[privacy] != null && <FormHelperText>{formik.errors[privacy]}</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={9}>
          <Button variant="contained" size="small" onClick={() => setShowPrivacyModal(true)}>
            {getMessageString(intl, BUTTON_DICHIARAZIONE)}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox checked={formik.values[newsletter]} onChange={(e) => formik.setFieldValue([newsletter], e.target.checked)} />}
            label={getMessageString(intl, NEWSLETTER_PLACEHOLDER)}
          />
        </Grid>
      </Grid>
      <ModalConsensi
        open={showAutocertificazioneModal}
        contenuto="autocert"
        onClose={() => setShowAutocertificazioneModal(false)}
        onAccept={() => {
          formik.setFieldValue([autocertificazione], true);
          setAutocertificazioneAccepted(true);
          setShowAutocertificazioneModal(false);
        }}
        showAccept={!autodichiarazioneAccepted}
      />
      <ModalConsensi
        open={showPrivacyModal}
        contenuto="gdpr"
        onClose={() => setShowPrivacyModal(false)}
        onAccept={() => {
          formik.setFieldValue([privacy], true);
          setPrivacyAccepted(true);
          setShowPrivacyModal(false);
        }}
        showAccept={!privacyAccepted}
      />
    </>
  );
});
